module.exports = __webpack_public_path__ + "99e214d4ae98e4f973bc9d923f5808e3.pdf";